import { render, staticRenderFns } from "./PotentialConfiguration.vue?vue&type=template&id=1da0ea3e&scoped=true&"
import script from "./PotentialConfiguration.vue?vue&type=script&lang=js&"
export * from "./PotentialConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PotentialConfiguration.vue?vue&type=style&index=0&id=1da0ea3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da0ea3e",
  null
  
)

export default component.exports